import {
  DUNGEON_FLOOR_CASH_COST,
  DUNGEON_FLOOR_SKU,
  grantDungeonFloorSlots,
  type DungeonMeta,
} from "@/dungeon/dungeon-meta";
import type { HomeEconomy, HomePurchaseRecord } from "@/home/economy";

function newPurchaseId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `purchase-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export type BuyDungeonFloorResult =
  | { ok: true; economy: HomeEconomy; meta: DungeonMeta; cashSpent: number }
  | { ok: false; reason: string };

export function buyDungeonFloorSlot(
  economy: HomeEconomy,
  meta: DungeonMeta,
): BuyDungeonFloorResult {
  const nextMeta = grantDungeonFloorSlots(meta, 1);
  if (!nextMeta) {
    return { ok: false, reason: "ซื้อชั้นด่านครบแล้ว" };
  }
  if (economy.wallet.cash < DUNGEON_FLOOR_CASH_COST) {
    return {
      ok: false,
      reason: `Cash ไม่พอ · ต้องการ ${DUNGEON_FLOOR_CASH_COST}`,
    };
  }

  const record: HomePurchaseRecord = {
    id: newPurchaseId(),
    sku: DUNGEON_FLOOR_SKU,
    kind: "dungeon_floor_slot",
    status: "mock_granted",
    createdAt: Date.now(),
    cashSpent: DUNGEON_FLOOR_CASH_COST,
    provider: "mock",
  };

  const nextEconomy: HomeEconomy = {
    ...economy,
    wallet: {
      ...economy.wallet,
      cash: economy.wallet.cash - DUNGEON_FLOOR_CASH_COST,
    },
    purchases: [record, ...economy.purchases].slice(0, 50),
  };

  return { ok: true, economy: nextEconomy, meta: nextMeta, cashSpent: DUNGEON_FLOOR_CASH_COST };
}
